import axios, { AxiosResponse } from "axios";
import { confirmer_ramassage_url } from "../constants/urls";

import { store } from "../store/store";
import { defaultHeadersWithToken } from "../constants/constants";
import { ReturnToCreate } from "@/interfaces/Return";
import { ServerResponse } from "@/interfaces/Server";

export async function confirmerRamassage(
  Return: ReturnToCreate
): Promise<AxiosResponse<ServerResponse>> {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse> = await axios({
      url: confirmer_ramassage_url,
      headers: defaultHeadersWithToken(accessToken),
      data: Return,
      method: "POST",
    });
    return response;
  } catch (error: any) {
    return error.response;
  }
}
